module.exports = __webpack_public_path__ + "img/0.446c54f6.png";